import { render } from "./DashboardUserOverview.vue?vue&type=template&id=ec1879b4&scoped=true"
import script from "./DashboardUserOverview.vue?vue&type=script&lang=js"
export * from "./DashboardUserOverview.vue?vue&type=script&lang=js"

import "./DashboardUserOverview.vue?vue&type=style&index=0&id=ec1879b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec1879b4"]])

export default __exports__